<template>
  <div class="row">
    <VeeForm
      class="col"
      v-slot="{ handleSubmit, meta }"
      :validation-schema="schema"
      as="div"
    >
      <div class="alert alert-danger d-none" id="alertError" role="alert"></div>
      <form
        @submit="handleSubmit($event, onSubmit)"
        class="row"
        id="generalityForm"
        ref="generalityForm"
      >
        <div class="col">
          <!-- //* Généralité -->
          <!-- <div class="alert alert-danger fs-5 mt-5 text-center" role="alert">
            Les candidatures sont closes.
          </div> -->
          <div class="row mb-2 mt-5">
            <div class="col mt-1">
              <h2 class="section-title text-uppercase">Généralités</h2>
            </div>
          </div>
          <div class="row">
            <!-- //? Civilité -->
            <div class="mb-4 col-lg-4 col-md-6 col-sm-12 col-12">
              <label for="first_name" class="form-label required">
                Civilité</label
              >
              <div class="form-check form-check">
                <Field
                  class="form-check-input"
                  type="radio"
                  name="radioGender"
                  id="radioMan"
                  value="M"
                  v-model="gender"
                />
                <label class="form-check-label" for="radioMan">
                  Monsieur
                </label>
              </div>
              <div class="form-check form-check">
                <Field
                  class="form-check-input"
                  type="radio"
                  name="radioGender"
                  id="radioWoman"
                  value="F"
                  v-model="gender"
                />
                <label class="form-check-label" for="radioWoman">
                  Madame
                </label>
              </div>
            </div>
            
            <!-- //? Nom -->
            <div class="mb-4 col-lg-4 col-md-6 col-sm-12 col-12">
              <label for="last_name" class="form-label required"> Nom </label>
              <Field
                name="last_name"
                type="text"
                label="nom"
                v-slot="{ field, errorMessage }"
                v-model="last_name"
              >
                <input
                  id="last_name"
                  v-bind="field"
                  placeholder="Saisissez un texte"
                  class="form-control"
                  :class="{ 'is-invalid': errorMessage }"
                />
              </Field>
              <ErrorMessage
                name="last_name"
                as="div"
                class="invalid-feedback"
              />
            </div>
            <!-- //? Prenom -->
            <div class="mb-4 col-lg-4 col-md-6 col-sm-12 col-12">
              <label for="first_name" class="form-label required">
                Prénom
              </label>
              <Field
                name="first_name"
                type="text"
                label="prénom"
                v-slot="{ field, errorMessage }"
                v-model="first_name"
              >
                <input
                  id="first_name"
                  v-bind="field"
                  placeholder="Saisissez un texte"
                  class="form-control"
                  :class="{ 'is-invalid': errorMessage }"
                />
              </Field>
              <ErrorMessage
                name="first_name"
                as="div"
                class="invalid-feedback"
              />
            </div>
            <!-- //? Date de naissance -->
            <div class="mb-4 col-lg-4 col-md-6 col-sm-12 col-12">
              <label for="birthdate" class="form-label required"
                >Date de naissance</label
              >
              <Field
                name="birthdate"
                label="date de naissance"
                v-slot="{ field, errorMessage }"
                v-model="birthdate"
              >
                <input
                  id="birthdate"
                  type="date"
                  v-bind="field"
                  class="form-control"
                  :class="{ 'is-invalid': errorMessage }"
                  max="2012-12-31"
                />
              </Field>
              <ErrorMessage
                name="birthdate"
                as="div"
                class="invalid-feedback"
              />
            </div>
            <!-- //? Pays d'origine -->
            <div class="mb-4 col-lg-4 col-md-6 col-sm-12 col-12">
              <label for="country" class="form-label required">Pays</label>
              <Field
                name="country"
                v-model="country"
                label="Pays d'origine"
                v-slot="{ field, errorMessage }"
              >
                <select
                  class="form-select"
                  id="country"
                  v-bind="field"
                  :class="{ 'is-invalid': errorMessage }"
                  aria-label="eeia candidature select"
                  @change="sendCountryChangeUpdate()"
                >
                  <option value="">Cliquer pour faire un choix</option>
                  <option
                    v-for="item in countries"
                    :key="item.value"
                    :value="item.value"
                  >
                    {{ item.text }}
                  </option>
                </select>
              </Field>
              <ErrorMessage name="country" as="div" class="invalid-feedback" />
            </div>
            
            <!-- //? Taille du t-shirt -->
            <div class="mb-4 col-lg-4 col-md-6 col-sm-12 col-12">
              <label for="size" class="form-label"
                >Taille du t-shirt</label
              ><label class="required"></label>
              <Field
                name="size"
                v-model="size"
                label="taille du t-shirt"
                v-slot="{ field, errorMessage }"
              >
                <select
                  class="form-select"
                  id="size"
                  v-bind="field"
                  :class="{ 'is-invalid': errorMessage }"
                  aria-describedby="sizeHelpBlock"
                >
                  <option value="">Faites un choix</option>
                  <option value="S">S</option>
                  <option value="M">M</option>
                  <option value="L">L</option>
                  <option value="XL">XL</option>
                  <option value="XXL">XXL</option>
                </select>
                <div id="sizeHelpBlock" class="form-text">
                  La taille du t-shirt que vous portez habituellement.
                </div>
              </Field>
              <ErrorMessage name="size" as="div" class="invalid-feedback" />
            </div>
          </div>

          <div class="row mb-4">
            <div>
              <button
                class="btn btn-primary mt-2 btn-lg"
                type="submit"
                id="submit-button"
              >
                <span v-if="step >= 3">Suivant</span>
                <span v-else>Suivant</span>
              </button>
            </div>
            <span class="text-danger d-none" id="form-invalid-error">
              <i v-if="!meta.valid">
                <!-- <img src="../assets/img/fail.svg" alt=""> -->
                Une ou plusieurs erreurs sont présentes dans le formulaire.
              </i>
            </span>
            <div class="mt-3 fst-italic">
              <span class="text-muted">
                <label class="required"></label> Obligatoire
              </span>
            </div>
          </div>
        </div>
      </form>
    </VeeForm>
  </div>
</template>

<script>
import { countries } from "./../countries";

import { Form as VeeForm, Field, ErrorMessage } from "vee-validate";
import { defineRule } from "vee-validate";
import { required } from "@vee-validate/rules";

import { setLocale } from "@vee-validate/i18n";
import { configure } from "vee-validate";
import { localize } from "@vee-validate/i18n";
import fr from "@vee-validate/i18n/dist/locale/fr.json";

import { library } from "@fortawesome/fontawesome-svg-core";
import { faInfoCircle } from "@fortawesome/free-solid-svg-icons";
// import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
library.add(faInfoCircle);

// const bootstrap = require('bootstrap')

configure({
  generateMessage: localize({
    fr,
  }),
});
setLocale("fr");

defineRule("required", required);

export default {
  name: "Generality",
  inject: [
    "ToastSuccess",
    "ToastError",
    "currentYearUrl",
    "AlertWarning",
    "AlertSuccess",
    "AlertError",
  ],
  components: {
    // Rename form to avoid confusion with native `form`
    VeeForm,
    Field,
    ErrorMessage,
    // FontAwesomeIcon,
  },
  props: {
    previousData: Object,
    step: Number,
    lastName: String,
    firstName: String,
  },
  mounted() {
    document
      .getElementById("submit-button")
      .addEventListener("click", function () {
        document
          .getElementById("form-invalid-error")
          .classList.remove("d-none");
      });

      // const tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="tooltip"]')
      // // eslint-disable-next-line no-unused-vars
      // const tooltipList = [...tooltipTriggerList].map(tooltipTriggerEl => new bootstrap.Tooltip(tooltipTriggerEl))
  },
  data() {
    const schema = {
      birthdate: "required",
      first_name: "required",
      last_name: "required",
      radioGender: "required",
      size: "required",
    };

    return {
      schema,
      birthdate: this.previousData.birthdate,
      last_name: this.lastName,
      first_name: this.firstName,
      country: this.previousData.country,
      countries: countries,
      gender: this.previousData.gender == "" ? "M" : this.previousData.gender,
      size: this.previousData.size,
    };
  },
  methods: {
    onSubmit(values, actions) {
      this.beforeSendPromise(values, this).then((formData) => {
        this.$http
          .post("new-candidacies", formData)

          .then(() => {
            this.$emit("to-next");
          })
          .catch((error) => {
            if (error.response.status == 422) {
              this.ToastError.fire({
                title: "Veuillez bien remplir le formulaire et réessayez.",
              });

              let errors = error.response.data.errors;
              for (const key in errors) {
                if (Object.prototype.hasOwnProperty.call(errors, key)) {
                  const element = errors[key];
                  actions.setFieldError(key, element);
                }
              }
            } else if (error.response.status == 403) {
              this.AlertError.fire({
                icon: "error",
                title: "Non autorisé",
                html: "Vous ne pouvez plus modifier votre candidature.",
              });
            } else {
              this.ToastError.fire({
                title: "Une erreur s'est produite, veuillez réessayer.",
              });
            }
          });
      });
    },
    beforeSendPromise(values, $this) {
      return new Promise(function (resolve) {
        values.step = 1;
        let formData = new FormData();
        formData.append("step", 1);

        formData.append("birthdate", $this.birthdate);
        formData.append("last_name", $this.last_name);
        formData.append("first_name", $this.first_name);
        formData.append("country", $this.country);
        formData.append("gender", $this.gender);
        formData.append("first_name", $this.first_name);
        formData.append("last_name", $this.last_name);
        formData.append("size", $this.size);

        resolve(formData);
      });
    },
    sendCountryChangeUpdate() {
      this.$emit("native-country-change", this.country);
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@media (min-width: 768px) {
  .form-control,
  .form-select {
    line-height: 2;
  }
}

.section-title {
  border-bottom: 3px solid #3490dc;
}
</style>
